module.exports = __webpack_public_path__ + "static/img/favicon.7aa7e511.png";